import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { ShowWidgetProps } from '../../utils/_declarations/globals';
import { Parameters } from '../_declarations/target';

interface AppState {
  consumerPayload?: ShowWidgetProps;
  initalDownPayment?: { deposit: number; depositWithVat: number };
  montlyPayload?: Parameters;
  promoCodeValidation?: boolean;

  selectedItem?: string;
  testPrupose?: boolean;
  updateWidget?: string;
  visibilityFeatures?: { [key: string]: boolean };
  widgetType?: 'embedded' | 'modal';
}

const appInitialState: AppState = {
  initalDownPayment: { deposit: 0, depositWithVat: 0 },
  widgetType: 'modal'
};

const appSlice = createSlice({
  initialState: appInitialState,
  name: 'app',
  reducers: {
    setDownPayment: (state, action) => {
      state.initalDownPayment = action.payload;
    },
    setPromoCodeValidation: (state, action) => {
      state.promoCodeValidation = action.payload;
    },

    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    setUpdateWidget: (state, action) => {
      state.updateWidget = uuidv4();
      state.consumerPayload = action.payload;
    },
    setVisibilityFeatures: (state, action) => {
      state.visibilityFeatures = action.payload;
    },
    setWidgetInitializationObject: (state, action) => {
      state.consumerPayload = action.payload;
    },
    setWidgetType: (state, action) => {
      state.widgetType = action.payload;
    }
  }
});

export const {
  setDownPayment,
  setPromoCodeValidation,
  setSelectedItem,
  setUpdateWidget,
  setVisibilityFeatures,
  setWidgetInitializationObject,
  setWidgetType
} = appSlice.actions;
export default appSlice.reducer;
